import { render } from "./ServiceAcknowledge.vue?vue&type=template&id=51942da7"
import script from "./ServiceAcknowledge.vue?vue&type=script&lang=js"
export * from "./ServiceAcknowledge.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__